// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vr_wD","colMin":"styles_colMin__Rd5Hx"};